
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, { useState, useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import { Pagination, Select } from "antd";
import { useDispatch } from "react-redux";

import { getCourseApi, buyCourseApi } from "@libs/apis/product";
import { getMeAction, walletMeAction } from "store/auth";

import { PAGE_SIZE_OPTIONS, LINK_DAOTAO } from "configs/constant";

import CardProduct from "@components/core/commons/CardProduct";
import AccessoriesItem from "@components/core/commons/AccessoriesItem";

const Courses = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("courses");

  const [listCourse, setListCourse] = useState({});
  const [showItemQty, setShowItemQty] = useState(0);
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState({});
  const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0].value);

  useEffect(() => {
    getCourseApi()
      .then((res) =>
        setListCourse(res?.data?.data?.filter((item) => item?.status !== 5)),
      ) // Ẩn các khoá học đã kết thúc (status = 5)
      .catch((err) => console.log("err", err));
  }, []);

  const handleChangePage = (page) => {
    setShowItemQty((page - 1) * pageSize);
    window.scroll({ top: 0, behavior: "smooth" });
  };

  const handleOnClickBuy = (item) => {
    if (item?.is_bought) {
      window.open(`${LINK_DAOTAO}/${item?.id}`);
    } else {
      setDetail(item);
      setVisible(true);
    }
  };

  const handleOnChangePageSzie = (e) => {
    if (e < pageSize) {
      window.scroll({ top: 0, behavior: "smooth" });
    }
    setPageSize(e);
  };

  const handleOnBuyCourse = (id) => {
    buyCourseApi({ courseId: id })
      .then(async () => {
        await setVisible(false);
        await dispatch(getMeAction());
        await dispatch(walletMeAction());
        getCourseApi()
          .then((res) => setListCourse(res?.data))
          .catch((err) => console.log("err", err));
      })
      .catch((err) => console.log("==err", err));
  };

  return (
    <div className="courses">
      <div className="courses__header">
        <div className="courses__header__content">
          <h1>{t("title")}</h1>
          <p>{t("content")}</p>
        </div>
      </div>
      <div className="courses__content">
        {listCourse?.length ? (
          <>
            <div className="courses__content__item">
              {listCourse
                ?.slice(showItemQty, showItemQty + pageSize)
                .map((item) => (
                  <CardProduct
                    key={item?.id}
                    data={item}
                    hasCourseTemplate
                    onClick={() => handleOnClickBuy(item)}
                  />
                ))}
            </div>
            <div className="courses__content__paginate">
              <Pagination
                className="paginate"
                pageSize={pageSize}
                total={listCourse?.length}
                onChange={handleChangePage}
                defaultCurrent={1}
              />
              <Select
                options={PAGE_SIZE_OPTIONS}
                defaultValue={PAGE_SIZE_OPTIONS[0]}
                onChange={(e) => handleOnChangePageSzie(e)}
              />
            </div>
          </>
        ) : (
          <div className="courses__content__empty">{t("empty")}</div>
        )}
      </div>

      {visible && (
        <AccessoriesItem
          usePoint={false}
          visible={visible}
          onCancel={() => setVisible(!visible)}
          data={detail}
          hasCourseTemplate
          handleChangeNow={(id) => handleOnBuyCourse(id)}
        />
      )}
    </div>
  );
};

export default Courses;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/product/courses',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  